import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import TextField from "../../shared/TextField/index.tsx";
import { useMenus } from "../../config/menus.tsx";
import Logo from "../../assets/emblem.webp";
import "../../styles/scss/Login.scss";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001/api/";

export default function Login() {
  const navigate = useNavigate();
  const { refresh: refreshMenus } = useMenus();

  const formik = useFormik({
    initialValues: { username: "", password: "" },
    validationSchema: Yup.object({
      username: Yup.string().required("Username is required"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
    }),
    onSubmit: async (values) => {
      try {
        const response = await fetch(`${API_URL}login`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(values),
        });
        const data = await response.json();
        if (data?.success && data?.data?.token) {
          localStorage.setItem("accessToken", data.data.token);
          toast.success("Login successful!");
          await refreshMenus();
          navigate("/admin/dashboard");
        } else {
          toast.error(data?.message || "Login failed");
        }
      } catch (error) {
        toast.error("An error occurred. Please try again.");
      }
    },
  });

  return (
    <Box className="login-page">
      <Box className="login-bg">
        <Box className="bg-gradient"></Box>
        <Box className="bg-grid"></Box>
        <Box className="bg-glow bg-glow-1"></Box>
        <Box className="bg-glow bg-glow-2"></Box>
      </Box>

      <Box className="login-content">
        <Box className="login-form-wrapper">
          <Box className="login-card">
            <Box className="card-accent"></Box>
            
            <Box className="login-logo-wrapper">
              <Box className="login-logo">
                <img src={Logo} alt="Marvel Mattress" />
              </Box>
            </Box>

            <Box className="login-header">
              <Typography className="login-title">Welcome Back</Typography>
              <Typography className="login-desc">Sign in to access your dashboard</Typography>
            </Box>

            <Box component="form" onSubmit={formik.handleSubmit} className="login-form">
              <Box className="form-field">
                <Typography className="field-label">Username</Typography>
                <TextField name="username" type="text" formik={formik} />
              </Box>

              <Box className="form-field">
                <Typography className="field-label">Password</Typography>
                <TextField name="password" type="password" formik={formik} />
              </Box>

              <button type="submit" className="login-btn" disabled={formik.isSubmitting}>
                {formik.isSubmitting ? (
                  <span className="spinner"></span>
                ) : (
                  <>
                    Sign In
                    <span className="material-symbols-outlined">arrow_forward</span>
                  </>
                )}
              </button>
            </Box>
          </Box>
        </Box>

        {/* <Box className="login-footer">
          <Typography>Developed by <strong>Codechip Technologies</strong></Typography>
        </Box> */}
      </Box>
    </Box>
  );
}
